import { useState, useEffect } from "react";
import { api } from "../../lib/api";
import { Badge } from "../ui/badge";
import { Loader2 } from "lucide-react";

/** P1-7: catálogo controlado de Tags ESG (antes texto libre por comas).
 * Selección por click sobre badges — sin inventar categorías nuevas, usa el
 * catálogo que sirve el backend (GET /initiatives/esg-tags-catalog). */
export function EsgTagsPicker({ token, selected, onChange }) {
  const [catalog, setCatalog] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getEsgTagsCatalog(token).then((d) => setCatalog(d.tags || [])).finally(() => setLoading(false));
  }, [token]);

  const toggle = (tag) => {
    if (selected.includes(tag)) onChange(selected.filter((t) => t !== tag));
    else onChange([...selected, tag]);
  };

  if (loading) return <Loader2 className="w-4 h-4 animate-spin text-muted-foreground" />;

  return (
    <div className="space-y-2" data-testid="esg-tags-picker">
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {selected.map((t) => (
            <Badge key={t} className="cursor-pointer" onClick={() => toggle(t)} data-testid={`esg-tag-selected-${t}`}>
              {t} ×
            </Badge>
          ))}
        </div>
      )}
      <div className="flex flex-wrap gap-1.5 max-h-40 overflow-y-auto border rounded-md p-2">
        {catalog.filter((t) => !selected.includes(t)).map((t) => (
          <Badge
            key={t}
            variant="outline"
            className="cursor-pointer hover:bg-muted"
            onClick={() => toggle(t)}
            data-testid={`esg-tag-option-${t}`}
          >
            + {t}
          </Badge>
        ))}
      </div>
    </div>
  );
}
